import TypesUtils from "../../utils/typesUtils";

class Vector {

    /**
     *
     * @param {*} valores valores del vector
     * @param {*} labels etiquetas de los valores del vector
     * @param {*} tieneDir Indica si el vector tiene direccion
     */
    constructor(valores, labels = null, conDir = false) {
        this.labels= labels;
        this.valores = valores;
        if (valores) {
            valores.forEach((id, index) => {
                this[id] = index;
            });
        }
        this.conDir= conDir;
    }

    tieneDir() {
        return this.conDir;
    }

    getDir() {
        return this.elementoDir;
    }

    getValue(index) {
        if (this.valores && this.valores.length > index) return this.valores[index];
        return null;
    }

    getLabel(index){
        if (this.labels && this.labels.length > index) return this.labels[index];
        return null;
    }

    hasId(id) {
        return TypesUtils.notUndefOrNull(this[id]);
    }

    size() {
        return this.valores.length;
    }

}

export { Vector as default };
